import { IS_EMAIL, IS_PHONE_NUMBER } from "../../utils/validators";
import { localisable } from "../../generic/localisable";
import { amountInputProps, commonInputStyleProps, commonPlaceholderProps, changePasswordInputStyleProps } from "./constants";

export const loginConfig = () => ({
    userName: {
        name: "userName",
        required: true,
        label: localisable.userName,
        type: 'text',
        placeholder: localisable.enterYourName,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...changePasswordInputStyleProps },
    },
    password: {
        name: "password",
        label: localisable.password,
        type: 'password',
        required: true,
        placeholder: localisable.enterYourPassword,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...changePasswordInputStyleProps },
    },
});

export const fpEmailConfig = () => ({
    email: {
        name: "email",
        label: localisable.email,
        type: 'email',
        required: true,
        validate: IS_EMAIL,
        placeholder: localisable.enterYourEmail,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '318px' } }
    },
});

export const fpTokenConfig = () => ({
    email: {
        name: "email",
        label: localisable.email,
        type: 'email',
        required: true,
        validate: IS_EMAIL,
        placeholder: localisable.enterYourEmail,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    token: {
        name: "token",
        label: localisable.token,
        type: 'text',
        required: true,
        placeholder: localisable.enterToken,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
});

export const fpResetPasswordConfig = () => ({
    email: {
        name: "email",
        label: localisable.email,
        type: 'email',
        required: true,
        validate: IS_EMAIL,
        placeholder: localisable.enterYourEmail,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    password: {
        name: "password",
        label: localisable.newPassword,
        type: 'text',
        required: true,
        placeholder: localisable.enterPassword,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    repeatPassword: {
        name: "repeatPassword",
        label: localisable.repeatPassword,
        type: 'text',
        required: true,
        placeholder: localisable.enterPassword,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
});

export const changePasswordConfig = () => ({
    oldPassword: {
        name: "oldPassword",
        label: localisable.enterOldPassword,
        type: 'text',
        required: true,
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    newPassword: {
        name: "newPassword",
        label: localisable.enterNewPassword,
        type: 'text',
        required: true,
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    reEnterNewPassword: {
        name: "reEnterNewPassword",
        label: localisable.reEnterNewPassword,
        type: 'text',
        required: true,
        inputStyleProps: { ...commonInputStyleProps, },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
});

export const paymentWorldPayConfig1 = () => ({
    amountProps: {
        name: "amountToBeConsidered",
        label: '',
        type: 'number',
        inputStyleProps: { ...amountInputProps, },
    },
    nameProps: {
        name: "cardHolderName",
        required: true,
        label: localisable.cardholderName,
        type: 'text',
        placeholder: localisable.enterName,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressProps: {
        name: "address",
        required: true,
        label: localisable.cardholderAddress,
        type: 'text',
        placeholder: localisable.enterAddress,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    zipCodeProps: {
        name: "zipCode",
        required: true,
        label: localisable.zipCode,
        type: 'text',
        placeholder: localisable.enterZipCode,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '132px', sm: '180px' } }
    },
    cardNumberProps: {
        name: "cardNumber",
        required: true,
        label: localisable.creditCardNumber,
        type: 'number',
        placeholder: localisable.enterCardNumber,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    cvvProps: {
        name: "cvv",
        label: localisable.cvv,
        type: 'number',
        placeholder: localisable.enterCvv,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '104px', sm: '120px' } }
    },
    expirationMonthProps: {
        name: "expirationMonth",
        required: true,
        label: localisable.expirationDate,
        wrapperProps: { w: { base: '240px', sm: '150px' } }
    },
    expirationYearProps: {
        name: "expirationYear",
        required: true,
        label: '',
        wrapperProps: { w: { base: '72px', sm: '96px' }, minW: '72px' }
    },
    enableAutopayProps: {
        name: "enableAutoPayments",
        label: '',
    },
});

export const autoPayWorldPayConfig1 = () => ({
    nameProps: {
        name: "cardHolderName",
        required: true,
        label: localisable.cardholderName,
        type: 'text',
        placeholder: localisable.enterName,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressProps: {
        name: "address",
        required: true,
        label: localisable.cardholderAddress,
        type: 'text',
        placeholder: localisable.enterAddress,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    zipCodeProps: {
        name: "zipCode",
        required: true,
        label: localisable.zipCode,
        type: 'text',
        placeholder: localisable.enterZipCode,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '132px', sm: '180px' } }
    },
    cardNumberProps: {
        name: "cardNumber",
        required: true,
        label: localisable.creditCardNumber,
        type: 'number',
        placeholder: localisable.enterCardNumber,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    cvvProps: {
        name: "cvv",
        label: localisable.cvv,
        type: 'number',
        placeholder: localisable.enterCvv,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '104px', sm: '120px' } }
    },
    expirationMonthProps: {
        name: "expirationMonth",
        required: true,
        label: localisable.expirationDate,
        wrapperProps: { w: { base: '240px', sm: '150px' } }
    },
    expirationYearProps: {
        name: "expirationYear",
        required: true,
        label: '',
        wrapperProps: { w: { base: '72px', sm: '96px' }, minW: '72px' }
    },
    enableAutopayProps: {
        name: "enableAutoPayments",
        label: '',
    },
});

export const paymentWorldPayConfig2 = () => ({
    amountProps: {
        name: "amountToBeConsidered",
        label: '',
        type: 'number',
        inputStyleProps: { ...amountInputProps, },
    },
    nameProps: {
        name: "firstName",
        required: true,
        label: localisable.firstName,
        type: 'text',
        placeholder: localisable.enterFirstName,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressLine1Props: {
        name: "addressLine1",
        required: true,
        label: localisable.addressLine1,
        type: 'text',
        placeholder: localisable.enterAddressLine1,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressLine2Props: {
        name: "addressLine2",
        required: true,
        label: localisable.addressLine2,
        type: 'text',
        placeholder: localisable.enterAddressLine2,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    zipCodeProps: {
        name: "zipCode",
        required: true,
        label: localisable.zipCode,
        type: 'text',
        placeholder: localisable.enterZipCode,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '132px' } }
    },
    cardNumberProps: {
        name: "cardNumber",
        required: true,
        label: localisable.creditCardNumber,
        type: 'number',
        placeholder: localisable.enterCardNumber,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    cvvProps: {
        name: "cvv",
        label: localisable.cvv,
        type: 'number',
        required: 'true',
        placeholder: localisable.enterCvv,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '120px' } }
    },
    cityProps: {
        name: "city",
        required: true,
        type: 'text',
        label: localisable.city,
        placeholder: localisable.enterCity,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '196px' } }
    },
    stateProps: {
        name: "state",
        required: true,
        label: localisable.state,
        placeholder: localisable.state,
        _placeholder: { ...commonPlaceholderProps },
        wrapperProps: { w: { base: '100%', sm: '132px' } }
    },
    expirationMonthProps: {
        name: "expirationMonth",
        required: true,
        label: localisable.expirationDate,
        wrapperProps: { w: { base: '240px', sm: '150px' } }
    },
    expirationYearProps: {
        name: "expirationYear",
        required: true,
        label: '',
        wrapperProps: { w: { base: '72px', sm: '96px' }, minW: '72px' }
    },
});

export const autoPayWorldPayConfig2 = () => ({
    nameProps: {
        name: "firstName",
        required: true,
        label: localisable.firstName,
        type: 'text',
        placeholder: localisable.enterFirstName,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressLine1Props: {
        name: "addressLine1",
        required: true,
        label: localisable.addressLine1,
        type: 'text',
        placeholder: localisable.enterAddressLine1,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressLine2Props: {
        name: "addressLine2",
        required: true,
        label: localisable.addressLine2,
        type: 'text',
        placeholder: localisable.enterAddressLine2,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    zipCodeProps: {
        name: "zipCode",
        required: true,
        label: localisable.zipCode,
        type: 'text',
        placeholder: localisable.enterZipCode,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '132px' } }
    },
    cardNumberProps: {
        name: "cardNumber",
        required: true,
        label: localisable.creditCardNumber,
        type: 'number',
        placeholder: localisable.enterCardNumber,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    cvvProps: {
        name: "cvv",
        label: localisable.cvv,
        type: 'number',
        required: 'true',
        placeholder: localisable.enterCvv,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '120px' } }
    },
    cityProps: {
        name: "city",
        required: true,
        type: 'text',
        label: localisable.city,
        placeholder: localisable.enterCity,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '196px' } }
    },
    stateProps: {
        name: "state",
        required: true,
        label: localisable.state,
        placeholder: localisable.state,
        _placeholder: { ...commonPlaceholderProps },
        wrapperProps: { w: { base: '100%', sm: '132px' } }
    },
    expirationMonthProps: {
        name: "expirationMonth",
        required: true,
        label: localisable.expirationDate,
        wrapperProps: { w: { base: '240px', sm: '150px' } }
    },
    expirationYearProps: {
        name: "expirationYear",
        required: true,
        label: '',
        wrapperProps: { w: { base: '72px', sm: '96px' }, minW: '72px' }
    },
    enableAutopayProps: {
        name: "enableAutoPayments",
        label: '',
    },
});

export const tenantFormConfig = () => ({
    firstNameProps: {
        name: "FirstName",
        label: localisable.firstName,
        type: 'text',
        placeholder: localisable.enterFirstName,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    lastNameProps: {
        name: "LastName",
        label: localisable.lastName,
        type: 'text',
        placeholder: localisable.enterLastName,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    phoneProps: {
        name: "Phone",
        label: localisable.phone,
        type: 'tel',
        validate: IS_PHONE_NUMBER,
        placeholder: localisable.enterPhoneNumber,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    emailProps: {
        name: "EmailAddress",
        label: localisable.emailAddress,
        type: 'email',
        validate: IS_EMAIL,
        placeholder: localisable.enterEmail,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressLine1Props: {
        name: "AddressLine1",
        label: localisable.addressLine1,
        type: 'text',
        placeholder: localisable.enterAddressLine1,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    addressLine2Props: {
        name: "AddressLine2",
        label: localisable.addressLine2,
        type: 'text',
        placeholder: localisable.enterAddressLine2,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '312px' } }
    },
    zipCodeProps: {
        name: "ZIP",
        required: true,
        label: localisable.zipCode,
        type: 'text',
        placeholder: localisable.enterZipCode,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '50%', sm: '132px' } }
    },
    cityProps: {
        name: "City",
        required: true,
        type: 'text',
        label: localisable.city,
        placeholder: localisable.enterCity,
        _placeholder: { ...commonPlaceholderProps },
        inputStyleProps: { ...commonInputStyleProps },
        wrapperProps: { w: { base: '100%', sm: '196px' } }
    },
    stateProps: {
        name: "State",
        required: true,
        label: localisable.state,
        placeholder: localisable.state,
        _placeholder: { ...commonPlaceholderProps },
        wrapperProps: { w: { base: '50%', sm: '132px' } }
    },
});